if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cartNotification = document.querySelector('cart-notification');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      const submitButton = this.querySelector('[type="submit"]');
      if (submitButton.classList.contains('loading')) return;

      this.handleErrorMessage();
      this.cartNotification.setActiveElement(document.activeElement);

      submitButton.setAttribute('aria-disabled', true);
      submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      formData.append('sections', this.cartNotification.getSectionsToRender().map((section) => section.id));
      formData.append('sections_url', window.location.pathname);
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);
            return;
          }

          this.cartNotification.renderContents(response);
        
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          submitButton.classList.remove('loading');
          submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
   $('#data_ne #drawer_cart_items').html('');

        fetch('/cart.js')
  .then((resp) => resp.json())
  .then((data) => {
   if(data.items.length > 0) {
                   var shortd = '';

       data.items.forEach(productsd => { 
         var nd = productsd.product_id;
 for(let t=0;t<myProductArray.length;t++){
var incStr = myProductArray[t].startsWith(nd);  
 if(incStr == true){
    var shortdata =  myProductArray[t].split(nd+'_').pop();
       shortd =   shortdata;                           
                                    }

      }
        var priceD = parseFloat(productsd.line_price)/100;
         var sellingPlanCheck =productsd.selling_plan_allocation;
                  var sellingPlanName = '';
         if(sellingPlanCheck){
         if(sellingPlanCheck.selling_plan.id == 'undefined'){
           var sellingPlanName = '';
         }else{
           var sellingPlanName =  '<span class="sellingname">'+sellingPlanCheck.selling_plan.name+'</span>';
         }
         }
         var myObj = productsd.properties;
         var array = $.map(myObj, function(value, index){
           return [value];
    });
         var n_p ='';
             
         $.each( array, function( index, value ) {
           var newValues = value;
           n_p = n_p.concat(newValues,'<br>');
         });
n_p = '<span class="pro">'+n_p+'</span>';
var options_with_values = productsd.options_with_values;
         var optionsT = '';
         for(let i = 0;i < options_with_values.length; i++){
         var colorName = options_with_values[i].name;
           var colorValue = options_with_values[i].value;
           if(colorName == 'Title'){
             
           }else{
             
             optionsT = '<span class="sellingname">'+colorName+':'+colorValue+'</span>';
           }
         }
         const template = '<div class="itemsc"><div class="n_P"><img src="' + productsd.featured_image.url + '" alt="' + productsd.featured_image.alt + '"></div><h5>'+productsd.product_title+'<span class="descript">'+shortd+'</span>'+n_p+sellingPlanName+optionsT+'<div class="qtyboxd"><div class="btnqtyd qtyminusd icon" data-productid="'+productsd.variant_id+'"><svg width="7" height="2" viewBox="0 0 7 2" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.32 0.000530899H6.084V1.36453H0.32V0.000530899Z" fill="black"/></svg></div><input type="text" id="quantity" name="quantity" value="'+ productsd.quantity +'" min="1" class="quantity-selector quantity-input" readonly=""><div class="btnqtyd qtyplusd icon" data-productid="'+productsd.variant_id+'"><svg width="10" height="9" viewBox="0 0 10 9" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.1 5.24453H5.38V8.88453H4.12V5.24453H0.4V4.06453H4.12V0.404531H5.38V4.06453H9.1V5.24453Z" fill="black"/></svg></div></div><div class="removeicon" data-productid="'+productsd.variant_id+'">Remove</div><p>$' + priceD.toFixed(2) + '</p></h5></div>';
         $('#drawer_cart_items').append(template);
      });

    }else {
                        $('#sub_c').hide();

  var cartEmpty = "{{ 'sections.cart.empty' | t }}";

      var suggestion = '{{ section.settings.suggestion }}';
   var suggestion_content = '{{ section.settings.suggestiondiv }}';
      document.getElementById('drawer_cart_items').innerHTML = '<div class="cart__warnings_th"><h1 class="cart__empty-text_p">'+cartEmpty+'</h1><h2 class="cart__empty-subheading">'+suggestion+'</h2><div class="suggestion_content">'+suggestion_content+'</div> </div><div class=" is-empty" id="main-cart-footer"><div class="cartfooter"><div class="cart__warnings subscriptionbox_s" style="background-color:#e1e07b"><h2>Save up to 20%</h2><p>Lorem ipsum dolor sit amet, consectetur adiping elit. Ut a nunc scelerisque.</p><div class="butndiv"><a href="">SUBSCRIPTIONS</a></div></div></div>';

    }
            var priceDd = parseFloat(data.total_price)/100;

    document.getElementById('cart__total_price').innerHTML = '$'+priceDd.toFixed(2);
  });
  $('#drawer-name').addClass("drawer is-active is-visible");
       $('#progrss').load(document.URL +  ' #trackprog');
       $('#checkout_div').load(document.URL +  ' #check_in');
       $('#progrss_c').load(document.URL +  ' #trackprog_c');
       $('#progrss_s').load(document.URL +  ' #track_s');
       $('#progrss_cd').load(document.URL +  ' #track_cd');
//         $('#cart-icon-bubbleinn').load(document.URL +  ' #dcart');
       $('#sub_c').show();
       $('#divd').load(document.URL +  ' #sp');
      $('#n_pd').load(document.URL +  ' #dcart');
       jQuery.getJSON('/cart.js', function(cart) {
           if(cart.item_count == 0){
             $('.cart--item').removeClass('cart-not-empty');
       $('.cart--item').addClass('cart-empty');
$('.cart-count-bubble').removeClass('cart-not-empty');
             $('.cart-count-bubble').addClass('cart-empty');
           }else{
 $('.cart--item').removeClass('cart-empty');
       $('.cart--item').addClass('cart-not-empty');
             $('.cart-count-bubble').removeClass('cart-empty');
             $('.cart-count-bubble').addClass('cart-not-empty');
     }
       });
        });
         
     
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}

document.getElementsByClassName('shopify-payment-button')[0].style.display = 'block'

